<template>
  <div class="wallet-page">
    <dialogTem :visible.sync="iswallet" :modalAppendToBody='false' :diaTitle="$t('walletlialog.WALLET')" :diaWidth="'430px'">
      <div class="balancelist-total">
        <div class="balancelist-group">
          <h3>
            <img src="./img/wallet_coin.png" alt />
            <span>&nbsp;{{accountBalance}}</span>
            <i @click="handleClickRefresh(2000)">
              <img :class="{rotate: isRotate}"  src="./img/balance-refresh.png" alt="Refresh" />
            </i>
          </h3>
          <ul class="balancelist-btn">
            <li @click="handleGoUrl('/mine/deposit')">
              <a href="javascript:void(0)" class="btn-deposit" title="Deposit">{{$t('walletlialog.Deposit')}}</a>
            </li>
            <li @click="handleGoUrl('/mine/withdrawal')">
              <a href="javascript:void(0)" class="btn-withdrawal" title="Withdraw" >{{$t('walletlialog.Withdraw')}}</a>
            </li>
          </ul>
        </div>
      </div>
      <!-- <div class="balancelist-title">
        {{$t('walletlialog.WalletDetails')}}
      </div> -->
      <!-- <div class="balancelist-content">
          <div class="balancelist-item" >
              <ul>
                  <li>{{$t('walletlialog.MainAccount')}}</li>
                  <li>{{mainBalance}}</li>
              </ul>
          </div>
          <empty v-if="gameAccountList.length===0" :describe="describe"></empty>
          <div v-show="gameAccountList.length!==0" v-for="(item,index) in gameAccountList" :key="index"  class="balancelist-item" >
              <ul>
                  <li>{{item.name}}</li>
                  <li>{{item.money}}</li>
              </ul>
          </div>
      </div> -->
    </dialogTem>
  </div>
</template>

<script>
import dialogTem from '../dialogTem'
import { mapState, mapMutations, mapActions } from "vuex";
import empty from '../empty/empty';
import { commonApi } from "@/common/index";
export default {
  name: "walletlialog",
  data(){
    return{
      iswallet:false,
      isRotate: false,
      isReady: true,  //节流
      describe: this.$t('walletlialog.NoDate'),
    }
  },
  components: { empty,dialogTem },
  computed: {
    ...mapState({
      accountBalance: (state) => state.userInfo.assetsInfoMap.accountBalance,
      mainBalance:state => state.userInfo.assetsInfoMap.mainBalance,
      gameAccountList:state => state.userInfo.assetsInfoMap.gameAccountList,
      UUID: state => state.UUID,
    }),
  },
  methods: {
    ...mapActions(['setCapitalIndexNav','getFirstInfo']),
    handleGoUrl(url){  
      this.$router.push({path:url})
      this.iswallet =!this.iswallet
    },
    handleClickRefresh(time=2000) {
      this.isRotate = true;
      if(this.isReady){
        this.isReady = false;
        setTimeout(()=>{
          this.refreshGameAccount();
        },time)
      }
    },
    refreshGameAccount() {
      if(this.UUID){
        commonApi.PAY.withdrawGames()
        this.$api.post(this.$urls.WALLET.refreshGameAccount,{  UUID: this.UUID },(resp)=>{
        this.isRotate = false;
        this.isReady = true;
        if(resp.data.code===200){
          this.getFirstInfo();
          this.$notify({
              duration:3000,
              title:this.$t('notify.success'),
              message: this.$t('walletlialog.refreshsuccess'),
              type: "success"
          });
        }else {
          let msg = resp.data.msg ? resp.data.msg :resp.data.message;
          this.$notify.error({
              title: this.$t('notify.error'),
              message: msg
          });
        }
        },err=>{this.isRotate = false;this.isReady = true;})
      }
    },
  },
};
</script>

<style scoped lang="scss">
// @import '../index.scss';
@keyframes rotate {
  0%{
    transform: rotate(0);
  }
  50%{
    transform:rotate(180deg);
  }
  100%{
    transform: rotate(360deg);
  }
}
@keyframes moveCircle {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
// 钱包弹框
.wallet-page {
  .balancelist-title{
      background: hsla(0,0%,100%,.05);
      padding: 10px 0;
      color: #222;
      font-size: 20px;
      text-align: center;
      text-transform: uppercase;
      position: relative;
      z-index: 9;
  }
  .balancelist-total{
      padding-bottom:28px;
  }
  .balancelist-group {
    position: relative;
    z-index: 9;
    padding: 0 0 15px;
    border-radius: 5px;
    &::after {
      content: "";
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
    h3 {
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top:20px;
      padding-bottom:20px;
      span {
        margin-right: 10px;
        font-size: 40px;
        color: #535557;
        font-weight: normal;
      }
      i {
        display: inline-block;
        width: 25px;
        height: 25px;
        cursor: pointer;
        img {
          width: 100%;
          margin-top: -5px;
        &.rotate{animation: rotate 0.5s linear infinite }
        }
      }
    }
  }
  .balancelist-btn{
    display: flex;
    align-items: center;
    justify-content: center;
    z-index:9;
    position: relative;
    li{
      display: inline-block;
      padding: 1%;
      a{
        display: block;
        font-size: 20px;
        margin: 1%;
        padding: 15px 5px;
        width: 180px;
        color: #222;
        text-align: center;
        cursor: pointer;
        background-image: linear-gradient(90deg, 
		#d1a968 0%, 
		#e2bf87 100%);
        border-radius: 6px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/common/walletlialog/index.vue